<div class="bg-blue dashboard-container">
  <div class="pb-5">
    <apc-navbar-big  [items]=navigation></apc-navbar-big >
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg">
        <router-outlet></router-outlet> 
      </div>
    </div>
  </div>
</div>